module.exports = __webpack_public_path__ + "img/Purdue.c341e267.png";